import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	label: {
		id: 'software-filters.filters.status.label',
		defaultMessage: 'Status',
		description: 'The label of a dropdown menu button used to choose status to filter issues by.',
	},
	placeholder: {
		id: 'software-filters.filters.status.placeholder',
		defaultMessage: 'Search status filters...',
		description: 'The placeholder label used for screen readers to announce the type of the filter',
	},
});
